import { Controller } from "@hotwired/stimulus"

// The Download PDF button on the resume export screen: opens the browser's
// print dialog, where the user picks "Save as PDF". Print-CSS in _resume.scss
// (@page Letter/A4 + print media rules) shapes the output; no server-side PDF.
export default class extends Controller {
    print() {
        window.print()
    }
}
